import {ArenaFiltersConfigurationMap} from "./arenas/arena-view-model.interface";
import {NullableUndefined} from "../../../../common/types/nullable-types";

export function filtersConfigurationToMap(filtersConfiguration: NullableUndefined<string[]>): ArenaFiltersConfigurationMap {
    return (filtersConfiguration ?? []).toDictionary(filterId => filterId, 
        (filterId, index) => {
            return {
                filterId: filterId,
                index: index
            }
        });
    }
